import { ExtendedWarrantySchema } from "@redotech/redo-model/extended-warranty";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getOrderRegistrationEligibility = {
  name: "getOrderRegistrationEligibility" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    canBeRegistered: z.boolean(),
    eligibleLineItemIds: z.array(z.string()),
    registrationsByLineItemId: z.record(z.string(), z.number()),
    productIdToCollectionTitles: z.record(z.string(), z.array(z.string())),
    existingExtendedWarranties: z.array(ExtendedWarrantySchema),
  }),
};
